var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToastWarn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_586_119724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9844 19.293C23.6609 20.4657 22.8117 21.9314 21.4605 21.9314H3.87209C2.5183 21.9314 1.67305 20.4634 2.34824 19.293L11.1426 4.0451C11.8194 2.87193 13.5146 2.87405 14.1903 4.0451L22.9844 19.293ZM12.6664 16.1406C11.7353 16.1406 10.9804 16.8954 10.9804 17.8265C10.9804 18.7576 11.7353 19.5125 12.6664 19.5125C13.5975 19.5125 14.3524 18.7576 14.3524 17.8265C14.3524 16.8954 13.5975 16.1406 12.6664 16.1406ZM11.0657 10.0804L11.3376 15.065C11.3503 15.2982 11.5432 15.4808 11.7768 15.4808H13.556C13.7896 15.4808 13.9825 15.2982 13.9952 15.065L14.2671 10.0804C14.2808 9.82848 14.0802 9.61663 13.8279 9.61663H11.5049C11.2525 9.61663 11.052 9.82848 11.0657 10.0804Z",
    fill: "#EA580C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_586_119724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.1111,
    height: 18.7654,
    fill: "white",
    transform: "translate(2.11133 3.16602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastWarn);
export default __webpack_public_path__ + "static/media/toastWarn.3d7914eafdd5bdd70ea46df2e05b6048.svg";
export { ForwardRef as ReactComponent };